import { pricingSimulatorDataContext } from 'contexts/PricingSimulatorContext';
import React, { useContext } from 'react';

const ProjectOverviewContainer = () => {
    const { selectedProjectInfo } = useContext(pricingSimulatorDataContext);
    if (selectedProjectInfo?.dataSource)
        return (
            <div className="flex items-baseline gap-3">
                <p className="font-xxs flex-shrink-0 text-fontGreyAlt">
                    <span>Source: </span>
                    <span>{selectedProjectInfo?.dataSource}</span>
                </p>
                <p className="font-xxs flex-shrink-0 text-fontGreyAlt">
                    <span>Simulation Period: </span>
                    <span>{selectedProjectInfo?.simulationPeriod}</span>
                </p>
                {selectedProjectInfo?.priceEffectiveDate && (
                    <p className="font-xxs flex-shrink-0 text-fontGreyAlt">
                        <span>Price Effective till: </span>
                        <span>{selectedProjectInfo?.priceEffectiveDate}</span>
                    </p>
                )}
                <p className="font-xxs flex-shrink-0 text-fontGreyAlt">
                    <span>{selectedProjectInfo?.dim1Filter?.attributeType}: </span>
                    <span>{selectedProjectInfo?.dim1Filter?.attributeNames}</span>
                </p>
                {selectedProjectInfo?.dim2Filter && (
                    <p className="font-xxs text-fontGreyAlt">
                        <span>{selectedProjectInfo?.dim2Filter?.attributeType}: </span>
                        <span>{selectedProjectInfo?.dim2Filter?.attributeNames}</span>
                    </p>
                )}
            </div>
        );

    return null;
};

export default ProjectOverviewContainer;
